import React, { useState, useEffect } from "react";
import PerformanceChart from "./PerformanceChart";
import SelectComponent from "../../../../ReusableComponents/SelectComponent";
import Popup from "../../../../ReusableFunctions/Popup";
import { getBhuMeetPerformanceAPI } from "../apis";

const Revenue = ({ labels, commonFilters }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [bhumeetPerformance, setBhumeetPerformance] = useState({});
  const [selectedSalesBy, setSelectedSalesBy] = useState({
    value: null,
    label: "All"
  })

  const getRevenuePerformace = async () => {
    try {
      setIsLoading(true)
      const bhumeetPerformance = await getBhuMeetPerformanceAPI({ ...commonFilters, salesBy: selectedSalesBy.value, performanceType: "revenue" })
      setBhumeetPerformance(bhumeetPerformance);
      setIsLoading(false)
    } catch (e) {
      Popup.alert("ERROR", "Error while getting performace data.", "ERROR")
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (commonFilters) getRevenuePerformace()
  }, [commonFilters, selectedSalesBy]);


  const salesByList = [{
    value: null,
    label: "All"
  }, {
    value: "BES",
    label: "Sales by BES"
  }, {
    value: "CS",
    label: "Sales by CS"
  }]
  return (
    <PerformanceChart
      header={{
        title: "Revenue",
        rightContent: <SelectComponent
          controlStyle={{ height: "30px", minHeight: "30px", background: "none", width: "150px", padding: "0px", border: "1px solid #ddd", boxShadow: "none", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
          isSearchable={true}
          menuStyles={{
            width: "150px"
          }}
          placeholder={"Select sales by..."}
          menuPlacement={"bottom"}
          list={salesByList}
          value={selectedSalesBy}
          optionStyle={{
            fontSize: "12px",
            height: "30px",
            minHeight: "30px"
          }}
          valueContainerStyle={{
            marginTop: "-2px"
          }}
          indicatorsContainerStyle={{
            marginTop: "-3px"
          }}
          onChange={(salesBy) => {
            setSelectedSalesBy(salesBy)
          }}
        />
      }}
      labels={labels}
      dataSetLabel="Revenue (₹)"
      prevMonthData={bhumeetPerformance.prevMonthData || 0}
      performanceData={bhumeetPerformance.chartData || []}
      isLoading={isLoading} />
  );
};

export default Revenue;
